import { render, staticRenderFns } from "./proejct.vue?vue&type=template&id=2eaaeb9b&scoped=true&"
import script from "./proejct.vue?vue&type=script&lang=js&"
export * from "./proejct.vue?vue&type=script&lang=js&"
import style0 from "./proejct.vue?vue&type=style&index=0&id=2eaaeb9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaaeb9b",
  null
  
)

/* custom blocks */
import block0 from "./proejct.vue?vue&type=custom&index=0&blockType=el-form&ref=form&%3Amodel=accountForm&label-position=left"
if (typeof block0 === 'function') block0(component)
import block1 from "./proejct.vue?vue&type=custom&index=1&blockType=div&class=tips"
if (typeof block1 === 'function') block1(component)
import block2 from "./proejct.vue?vue&type=custom&index=2&blockType=span&slot=footer&class=dialog-footer"
if (typeof block2 === 'function') block2(component)

export default component.exports